export default __webpack_public_path__ + "static/media/doodle.9d844a0e.png";